<template>
    <div
    v-html="textBottomLabel"
    class="image-bottom-label-second"
    >
    </div>
</template>
  
<script>

export default {
    name: 'ImageBottomLabelSecond',
    props: {
        textBottomLabel: String
    }    
}
</script>
  
<style>

</style>